import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { VSheet } from 'vuetify/lib';
export default {
  functional: true,
  render: function render(h, _ref) {
    var _data$attrs$height, _data$attrs;
    var data = _ref.data,
      children = _ref.children;
    return h(VSheet, _objectSpread(_objectSpread({}, data), {}, {
      props: {
        height: (_data$attrs$height = (_data$attrs = data.attrs) === null || _data$attrs === void 0 ? void 0 : _data$attrs.height) !== null && _data$attrs$height !== void 0 ? _data$attrs$height : 56
      },
      class: ['py-4 px-2', _objectSpread({}, data.class)]
    }), children);
  }
};